var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sso_container" }, [
    _c(
      "div",
      { staticClass: "container_lf" },
      [
        _c(
          "el-carousel",
          { attrs: { interval: 5000, arrow: "always" } },
          _vm._l(_vm.imgLists, function (item) {
            return _c("el-carousel-item", { key: item }, [
              _c("img", { staticClass: "imgs", attrs: { src: item, alt: "" } }),
            ])
          }),
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "container_rg" }, [
      _vm._m(0),
      _c("div", { staticClass: "rg_content" }, [
        _c("div", { staticClass: "content" }, [
          _c("p", { staticClass: "welcome" }, [_vm._v("欢迎,")]),
          _c("p", { staticClass: "tip" }, [
            _vm._v("请在下面选择您的角色以开始使用:"),
          ]),
          _c(
            "div",
            {
              staticClass: "role",
              on: {
                click: function ($event) {
                  return _vm.goPage(0)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/img/company.png"),
                  alt: "",
                },
              }),
              _c("p", { staticClass: "labor" }, [_vm._v("公司员工")]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "role",
              on: {
                click: function ($event) {
                  return _vm.goPage(1)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/img/restaurant.png"),
                  alt: "",
                },
              }),
              _c("p", { staticClass: "labor" }, [_vm._v("餐厅员工")]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "role",
              on: {
                click: function ($event) {
                  return _vm.goPage(2)
                },
              },
            },
            [
              _c("img", {
                staticStyle: { "margin-right": "20px" },
                attrs: {
                  src: require("../../assets/img/supplier1.png"),
                  alt: "",
                },
              }),
              _c("p", { staticClass: "labor" }, [_vm._v("供应商")]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rg_logo" }, [
      _c("img", {
        attrs: {
          src: "https://gas.mcd.com/API/adfs/portal/images/new/logo.png",
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }